

import { BsLink45Deg } from '@react-icons/all-files/bs/BsLink45Deg'
import { FcCalendar } from '@react-icons/all-files/fc/FcCalendar'
import { Btn, Card } from 'mga-commons'
import React, { Suspense, useRef } from 'react'
import { toastr } from 'react-redux-toastr'
import { useNavigate } from 'react-router-dom'
import ImagesFiche from '../../components/anonymous/fiche/ImagesFiche'
import InfosAcces from '../../components/anonymous/fiche/InfosAcces'
import InfosContacts from '../../components/anonymous/fiche/InfosContacts'
import InfosFormation from '../../components/anonymous/fiche/InfosFormations'

import InfosSpecialites from '../../components/anonymous/fiche/InfosSpecialites'
import InfosUtiles from '../../components/anonymous/fiche/InfosUtiles'
import NotifInfo from '../../components/commons/notifs/NotifInfo/NotifInfo'
import { EnumProfil, EnumTypeFiche } from '../../utils/EnumApp'
import { getUrlFromIdTypeFiche } from '../../utils/StringUtils'
import './PageFicheConsultationDesktop.css'

const InfosRdvs = React.lazy(() => import('../../components/anonymous/fiche/InfosRdvs'))
const MapLocation = React.lazy(() => import('../../components/commons/MapLocation'))

const PageFicheConsultationDesktop = ({ item, userProfile }) => {

    const rdvBloc = useRef(null)
    const navigate = useNavigate()

    const handleSmoothScrol = () => {
        rdvBloc?.current?.scrollIntoView({
            behavior: "smooth"
        })
    }

    const handleSubscribe = () => {

        const toastrConfirmOptions = {
            transitionIn: 'bounceInDown',
            okText: 'Valider',
            cancelText: 'Annuler',
            component: () => <NotifInfo title="Connexion ?" message={`Connectez-vous pour prendre rendez-vous`} />,
            onOk: () => {
                navigate('/connexion?from=' + window.location.pathname)
            }
        }
        toastr.confirm(null, toastrConfirmOptions)
    }

    const renderRdvs = () => {

        if (item.EstUtilisateur) {

            if (item.EstActifRdv) {

                if (userProfile && userProfile.Profil === EnumProfil.Patient.value) {
                    return (
                        <>
                            <Card margin="40px 0 20px 0">
                                <span id="rdvs-bloc" ref={rdvBloc}></span>
                                <div className="rdv-title">
                                    Réserver votre rendez-vous
                                </div>
                                <Suspense fallback="">
                                    <InfosRdvs item={item} />
                                </Suspense>
                            </Card>
                        </>
                    )
                } else {
                    return (
                        <img
                            alt="Réserver un rendez-vous"
                            loading="lazy"
                            style={{ cursor: 'pointer', margin: 'auto', display: 'flex', maxWidth: '100%' }}
                            onClick={handleSubscribe}
                            src="./images/capture-min.webp"
                            ref={rdvBloc} />
                    )
                }
            }
            return (
                <Card margin="40px 0 20px 0">
                    <div className="subscribe-message">
                        Les rendez-vous sont <strong style={{ color: 'red' }}>momentanément indisponibles</strong>.
                        <br />
                        Veuillez contacter votre praticien directement.
                    </div>
                </Card>
            )

        } else {
            // Pas utilisateur
            return (
                <Card margin="40px 0 20px 0">
                    <div className="subscribe-message">
                        C'est votre établissement ? <span className="subscribe-link" onClick={() => navigate('/inscription-pro?from=' + window.location.pathname)}>Inscrivez-vous ici ! </span>
                    </div>
                </Card>
            )
        }
    }

    const urlTypeEntite = getUrlFromIdTypeFiche(item.IdTypeFiche, item.IdTypeMedecin, item.IdTypeEtablissement, item.IdTypeService)

    return (
        <div className="page-fiche-consultation-desktop">
            <Card margin="20px 0 20px 0" className="infos">
                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
                    <ImagesFiche item={item} />
                    <div style={{ display: 'flex', alignItems: 'stretch', flexGrow: 1, flexWrap: 'wrap' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                            <h1 className="fiche-libelle">Dr. {item.LibelleAffichage}</h1>
                            <div>
                                {item.EstActifRdv &&
                                    (
                                        <Btn onClick={handleSmoothScrol} margin="auto auto 40px 40px" maxWidth="350px">
                                            <FcCalendar size="32" />
                                            &nbsp;&nbsp;
                                            <strong>Prendre un rendez-vous</strong>
                                        </Btn>
                                    )
                                }
                            </div>
                        </div>
                        <div className="specialite-container">
                            <span>Spécialité</span>
                            <a href={urlTypeEntite} title={'Spécialité ' + item.LibelleTypeEntite} target="_blank" rel="noreferrer">
                                <h2> <BsLink45Deg />{item.LibelleTypeEntite}</h2>
                            </a>
                        </div>
                    </div>
                </div>
            </Card>
            <Card margin="40px 0 20px 0" className="contacts">
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <InfosSpecialites item={item} />
                    <InfosContacts item={item} />
                </div>
            </Card>
            {renderRdvs()}
            <Card margin="40px 0 20px 0" className="acces">
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <InfosAcces item={item} />
                    <MapLocation item={item} />
                </div>
            </Card>
            <Card margin="40px 0 20px 0" className="formation">
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {
                        item.IdTypeFiche === EnumTypeFiche.Medecin.Value &&
                        (
                            <div className="flex300px">
                                <InfosFormation item={item} />
                            </div>
                        )
                    }
                    <InfosUtiles item={item} />
                </div>
            </Card>
            <br />
            <br />
            <br />
        </div>
    )
}

export default PageFicheConsultationDesktop
